$(document).ready(function () {
	if(isElemExist('.page-acimaSupportPage')) {
		$('.faq-section-content-left').on('click', 'li[id]', function (event) {
			event.preventDefault();
			let id = $(this).attr('id');
			let currentURL = window.location.href;
			let trimmedURL = currentURL.split('/support')[0] + '/support';
			let newURL = trimmedURL + "/" + id;
			window.history.pushState({}, '', newURL);
			handleUrlChange();
		});
		window.addEventListener('popstate', function (event) {
			handleUrlChange();
		});

		handleUrlChange();
	}
});

function handleUrlChange() {
	$(".faq-main-data .faq-section-right").addClass('d-none')
	$('.faq-section-content-left li').removeClass('active');

	if( $(window).width() < 768) {
		$('html, body').animate({
			scrollTop: 0
		}, 'slow');
	}
	else {
		let sectionPosition = $('.faq-sections').offset().top;
		$('html, body').animate({
			scrollTop: sectionPosition
		}, 'slow');
	}

	let params = window.location.href.split('support/')[1];
	if (isNullUndefined(params)) {
		params = $('.faq-section-content-left ul li').first().attr('id');
	}
	else {
		let pageTitle=$(".faq-main-data .faq-section-right#" + params).data('title');
		if(isNullUndefined(pageTitle))
		{
			document.title = "ACIMA";	
		}else{
			document.title = pageTitle;
		}
		 
	}
	$(".faq-section-content-left #" + params).addClass("active");
	$(".faq-main-data .faq-section-right#" + params).removeClass("d-none");
}